// Mock data — backend integration ke liye baad me replace hoga (contracts.md follow karke)

export const personalInfo = {
  name: "Vedant Bora",
  firstName: "Vedant",
  title: "Java Backend Developer",
  tagline: "I build scalable systems.",
  email: "vedantbora9823@gmail.com",
  phone: "+91 9823038829",
  linkedin: "https://www.linkedin.com/in/vedant-bora-79b73a3a0",
  github: "https://github.com/vedbora",
  location: "Solapur, Maharashtra",
  resumeUrl:
    "https://customer-assets.emergentagent.com/job_5e468d03-7d68-41a6-8bd9-e72cf71e6cec/artifacts/w1e05do8_Vedant%20Bora-2.pdf",
  avatarUrl: "/models/avatar.glb",
  photoUrl:
    "https://customer-assets.emergentagent.com/job_5e468d03-7d68-41a6-8bd9-e72cf71e6cec/artifacts/52bss20x_my%20pic.jpeg",
  shortBio:
    "Backend engineer focused on Java, Spring Boot, Kafka, and REST APIs. I love designing distributed systems that stay calm under heavy load.",
  longBio:
    "I'm a backend-focused software engineer pursuing B.Tech in Information Technology. My playground is the JVM — I build production-style services with Spring Boot, async pipelines with Apache Kafka, and clean REST APIs backed by MySQL. I care about correctness, throughput, and code that other engineers can read at 2 AM."
};

// Spring Boot boot sequence for loading screen
export const bootLogs = [
  { type: "banner", delay: 0 },
  { type: "info", text: "Starting VedantApplication using Java 17 on vedant-dev", delay: 300 },
  { type: "info", text: "No active profile set, falling back to default profiles: 'default'", delay: 420 },
  { type: "info", text: "Bootstrapping Spring Data JPA repositories in DEFAULT mode", delay: 540 },
  { type: "info", text: "Tomcat initialized with port(s): 8080 (http)", delay: 660 },
  { type: "info", text: "Kafka producer bound to broker @ localhost:9092", delay: 780 },
  { type: "success", text: "Loaded modules  [ java • spring-boot • kafka • mysql • hibernate ]", delay: 920 },
  { type: "success", text: "Started VedantApplication in 2.347 seconds (JVM running)", delay: 1120 },
  { type: "ready", text: "Portfolio ready → http://localhost:8080", delay: 1260 }
];

// Terminal typewriter lines for Hero
export const terminalLines = [
  { type: "prompt", text: "whoami", delay: 200 },
  { type: "output", text: "vedant — backend engineer", delay: 320 },
  { type: "prompt", text: "curl -s http://localhost:8080/api/profile | jq", delay: 480 },
  { type: "json", text: "{", delay: 620 },
  { type: "json", text: '  "name": "Vedant Bora",', delay: 720 },
  { type: "json", text: '  "role": "Java Backend Developer",', delay: 820 },
  { type: "json", text: '  "stack": ["Spring Boot", "Kafka", "MySQL"],', delay: 920 },
  { type: "json", text: '  "shipped": 3,', delay: 1020 },
  { type: "json", text: '  "available": true', delay: 1120 },
  { type: "json", text: "}", delay: 1220 },
  { type: "prompt", text: "scroll ↓  or press  ⌘ K  to explore", delay: 1380, hint: true }
];

export const projects = [
  {
    id: 1,
    title: "ResQride",
    subtitle: "Privacy-first vehicle contact & accident detection",
    branch: "main",
    commits: 42,
    status: "deployed",
    problem:
      "Vehicle owners need to be reachable in emergencies without exposing personal phone numbers, and highway accidents often go unreported due to delayed help.",
    solution:
      "QR-based vehicle identification with masked communication, plus real-time accident detection using accelerometer & gyroscope sensor data.",
    impact:
      "Cuts emergency response time and protects user identity with a low-latency backend handling real-time alert dispatch.",
    techStack: ["Java", "Spring Boot", "MySQL", "REST APIs", "QR", "Sensors"],
    liveUrl: "https://resqride-1.onrender.com",
    githubUrl: "https://github.com/vedbora",
    period: "Jan 2026 – Mar 2026",
    accent: "cyan",
    files: ["AccidentDetector.java", "QrController.java", "AlertService.java"]
  },
  {
    id: 2,
    title: "Wallet Transaction System",
    subtitle: "High-concurrency wallet backend with Kafka",
    branch: "main",
    commits: 67,
    status: "production",
    problem:
      "Wallet systems break under concurrent load — race conditions, double-spends, and inconsistent balances during peak usage.",
    solution:
      "Spring Boot service with 10+ REST APIs and Apache Kafka for asynchronous processing, backed by ACID-compliant H2/MySQL transactions.",
    impact:
      "Handles 100+ concurrent transactions reliably, with global exception handling that drops API failure rate to near-zero.",
    techStack: ["Spring Boot", "Apache Kafka", "MySQL", "H2", "Postman"],
    liveUrl: "",
    githubUrl: "https://github.com/vedbora/wallet-transaction-system",
    period: "Nov 2025 – Dec 2025",
    accent: "amber",
    files: ["WalletController.java", "KafkaConsumer.java", "TransactionEntity.java"]
  },
  {
    id: 3,
    title: "MindQuest",
    subtitle: "AI-powered mental health companion with 3D avatars",
    branch: "main",
    commits: 89,
    status: "live",
    problem:
      "Mental health tools feel clinical and impersonal — users drop off because there's no empathy, no engagement, and no real feedback loop.",
    solution:
      "Full-stack wellness platform with JWT auth, AI conversations powered by Google Generative AI, daily mood reports, gamified rewards, and expressive 3D avatars (ReadyPlayerMe) rendered via React Three Fiber.",
    impact:
      "Combines clinical structure with engaging UX — AI-driven reflections, reward streaks, and avatar feedback keep users consistent with their mental health routines.",
    techStack: [
      "Node.js",
      "Express",
      "MySQL",
      "JWT",
      "Google Generative AI",
      "React",
      "Three.js",
      "Zustand"
    ],
    liveUrl: "",
    githubUrl: "https://github.com/vedbora/MindQuest",
    period: "2025",
    accent: "emerald",
    files: ["aiService.js", "auth.js", "dailyReports.js", "rewards.js"]
  },
  {
    id: 4,
    title: "Vital",
    subtitle: "Real-time hospital communication platform",
    branch: "main",
    commits: 54,
    status: "production",
    problem:
      "Hospitals rely on fragmented messaging — nurses and doctors miss critical patient updates because WhatsApp and SMS aren't role-aware or auditable.",
    solution:
      "Role-based (doctor / nurse / patient / admin) messaging backend with JWT auth, thread-per-case architecture, Sequelize ORM on MySQL, and Socket.io broadcasting for instant delivery.",
    impact:
      "Replaces ad-hoc channels with a purpose-built clinical comms tool — every message is tied to a patient thread, authenticated, and pushed in real-time.",
    techStack: [
      "Node.js",
      "Express",
      "Sequelize",
      "MySQL",
      "Socket.io",
      "JWT",
      "React"
    ],
    liveUrl: "",
    githubUrl: "https://github.com/vedbora/Vital",
    period: "2025",
    accent: "cyan",
    files: ["auth.controller.js", "threads.model.js", "sockets.js"]
  },
  {
    id: 5,
    title: "WIT Boys Hostel",
    subtitle: "Full-stack hostel administration with payments",
    branch: "main",
    commits: 71,
    status: "live",
    problem:
      "Manual hostel operations cause inefficiencies in room allocation, fee collection, complaint handling, and student record-keeping.",
    solution:
      "Dockerized stack with FastAPI backend (async MySQL via aiomysql), React frontend, Razorpay payment integration, and Resend email workflows — role-based dashboards for admins and students.",
    impact:
      "Digitized the entire hostel workflow — online fee payment, complaint tracking, and student onboarding. Deployed on Render with zero-downtime blueprints.",
    techStack: [
      "Python",
      "FastAPI",
      "MySQL",
      "React",
      "Docker",
      "Razorpay",
      "JWT"
    ],
    liveUrl: "https://wit-boys-hostel-1.onrender.com/",
    githubUrl: "https://github.com/vedbora",
    period: "2025",
    accent: "amber",
    files: ["server.py", "models.py", "database.py"]
  }
];

// pom.xml style dependencies for Skills
export const skillGroups = [
  {
    category: "languages",
    artifact: "languages",
    icon: "Code2",
    items: ["Java", "JavaScript", "Python", "SQL"]
  },
  {
    category: "frameworks",
    artifact: "frameworks",
    icon: "Layers",
    items: ["Spring Boot", "Hibernate", "Express.js", "FastAPI", "Sequelize"]
  },
  {
    category: "tooling",
    artifact: "tooling",
    icon: "Wrench",
    items: ["Apache Kafka", "Socket.io", "Docker", "Git", "Postman"]
  },
  {
    category: "databases",
    artifact: "databases",
    icon: "Database",
    items: ["MySQL", "H2"]
  },
  {
    category: "concepts",
    artifact: "concepts",
    icon: "Cpu",
    items: [
      "REST APIs",
      "OOP",
      "DSA",
      "System Design",
      "Distributed Systems",
      "Async Processing",
      "JWT Auth",
      "Real-time"
    ]
  }
];

export const experience = [
  {
    company: "JP Morgan Chase",
    role: "Software Engineering Virtual Intern",
    type: "Forage · Remote",
    period: "2025",
    commit: "feat: spring-boot rest apis + kafka integration",
    points: [
      "Developed multiple REST APIs using Spring Boot for backend services.",
      "Integrated Apache Kafka for event-driven message processing.",
      "Implemented database persistence using H2 and tested backend workflows."
    ]
  },
  {
    company: "Amazon",
    role: "Solutions Architecture Virtual Intern",
    type: "Forage · Remote",
    period: "2025",
    commit: "feat: scalable architecture design patterns",
    points: [
      "Designed scalable architecture solutions for real-world business scenarios.",
      "Applied cloud architecture concepts: scalability, availability, fault tolerance.",
      "Developed structured backend solutions based on business requirements."
    ]
  }
];

export const githubRepos = [
  {
    name: "MindQuest",
    description:
      "AI-powered mental health companion with Google Generative AI chat, gamified rewards, and 3D ReadyPlayerMe avatars.",
    techStack: ["Node.js", "Express", "MySQL", "React", "Three.js"],
    url: "https://github.com/vedbora/MindQuest",
    language: "JavaScript"
  },
  {
    name: "Vital",
    description:
      "Real-time hospital communication platform. Role-based messaging for doctors, nurses, patients and admins via Socket.io.",
    techStack: ["Node.js", "Express", "Sequelize", "MySQL", "Socket.io"],
    url: "https://github.com/vedbora/Vital",
    language: "JavaScript"
  },
  {
    name: "wallet-transaction-system",
    description:
      "Scalable wallet backend with Spring Boot & Kafka. 10+ REST APIs handling 100+ concurrent transactions.",
    techStack: ["Java", "Spring Boot", "Kafka"],
    url: "https://github.com/vedbora/wallet-transaction-system",
    language: "Java"
  }
];

export const resumeHighlights = {
  education: {
    institution: "Walchand Institute of Technology, Solapur",
    degree: "B.Tech, Information Technology",
    cgpa: "8.0",
    year: "2027"
  },
  certifications: [
    {
      name: "Software Engineer Intern Certification",
      issuer: "HackerRank",
      year: "2025"
    },
    {
      name: "Java (Basic) Certification",
      issuer: "HackerRank",
      year: "2025"
    }
  ],
  quickStats: [
    { label: "Concurrent TXs handled", value: "100+" },
    { label: "REST APIs shipped", value: "25+" },
    { label: "Live Projects", value: "5" },
    { label: "CGPA", value: "8.0" }
  ]
};

// System architecture graph nodes for architecture section
export const archNodes = [
  { id: "client", label: "Client", sub: "Browser / Mobile", x: 5, y: 50, type: "client" },
  { id: "gateway", label: "API Gateway", sub: "Spring Cloud", x: 25, y: 50, type: "service" },
  { id: "auth", label: "Auth Service", sub: "JWT + Security", x: 50, y: 18, type: "service" },
  { id: "wallet", label: "Wallet Service", sub: "Spring Boot", x: 50, y: 50, type: "service" },
  { id: "notify", label: "Notification", sub: "Async Worker", x: 50, y: 82, type: "service" },
  { id: "kafka", label: "Apache Kafka", sub: "Event Bus", x: 72, y: 50, type: "broker" },
  { id: "mysql", label: "MySQL", sub: "Primary DB", x: 92, y: 30, type: "db" },
  { id: "cache", label: "In-Memory", sub: "H2 / Redis", x: 92, y: 70, type: "db" }
];

export const archEdges = [
  { from: "client", to: "gateway" },
  { from: "gateway", to: "auth" },
  { from: "gateway", to: "wallet" },
  { from: "gateway", to: "notify" },
  { from: "wallet", to: "kafka" },
  { from: "notify", to: "kafka" },
  { from: "kafka", to: "mysql" },
  { from: "kafka", to: "cache" }
];

export const navLinks = [
  { label: "About", href: "#about", hint: "a" },
  { label: "System", href: "#system", hint: "s" },
  { label: "Projects", href: "#projects", hint: "p" },
  { label: "Skills", href: "#skills", hint: "k" },
  { label: "Experience", href: "#experience", hint: "e" },
  { label: "GitHub", href: "#github", hint: "g" },
  { label: "Contact", href: "#contact", hint: "c" }
];
